module.exports = __webpack_public_path__ + "img/eat.285b5b4e.png";